@if(currentStep) {
  <p-card class="custom-card">
    <div class="grid align-items-center gap-1" style="margin-bottom: -0.5rem">
      <div class="lg:col-12 md:col-12 sm:col-12">

        <div class="h-full flex align-items-center">
          <p class="font-semibold">
            {{ currentStep.text | translate }}
            @for (text of currentStep.texts; track $index) {
              {{ text | translate }}
            }
          </p>
        </div>
      </div>
      <div [class]="currentStep.id != 1 ? 'lg:col-6 md:col-12 sm:col-12' : 'lg:col-6 md:col-12 sm:col-12'">
        <div class="hidden sm:inline-block vertical-align-middle w-full" style="padding-top: 8px">
          <p-timeline [value]="steps" layout="horizontal" class="custom-timeline">
            <ng-template pTemplate="marker" let-event>
              <p-tag
                [value]="event.value"
                [severity]="event.severity"
                [class]="'step-tag-smaller'"
                [styleClass]="event.severity">
              </p-tag>
            </ng-template>
            <ng-template pTemplate="content" let-event>
              <div class="flex align-items-center text-justify p-1 custom-text">
                {{ event.label | translate }}
              </div>
            </ng-template>
          </p-timeline>
        </div>
      </div>
      <div class="lg:col-5 md:col-12 sm:col-12 flex align-items-center justify-content-end">
        <div class="inline-block vertical-align-middle">
          @if (currentStep.id != 1) {
            <p-button
              severity="success" 
              label="{{ 'buttons.next' | translate }}"
              icon="pi pi-arrow-right"
              iconPos="right"
              [style]="{ 'font-size': '2.2rem', 'padding': '1rem 2rem' }"
              (click)="nextStep()">
            </p-button>
          }
        </div>
      </div>
    </div>
  </p-card>
  <div class="h-1rem"></div>
  <p-card>
    <div style="min-height: calc(100vh - 250px)">
      @if (currentStep.id === 1) {
        <div class="col-12 grid">
          <div class="sm:col-12 md:col-6 md:col-offset-3">
            <div class="identification-zone flex flex-column align-items-center">
              <div class="identification-header">
                <h5>
                  <i class="pi pi-hourglass text-xl pr-3"></i>{{ "importWorkflow.identificationHeader" | translate }}
                </h5>
              </div>
              <div class="identification-text">
                {{ "importWorkflow.identificationText" | translate }}
              </div>
              <div class="identification-footer mt-7 w-full flex justify-content-between">
                <div>
                  <p-button severity="danger" styleClass="vertical-align-middle">
                    <i class="pi pi-times-circle"></i>
                    <span class="pl-2" style="font-weight: 600">{{ "importWorkflow.cancelImport" | translate }}</span>
                  </p-button>
                </div>
                <div>
                  <p-button (click)="navigate('/')" [outlined]="true" styleClass="vertical-align-middle">
                    <i class="pi pi-sign-out"></i>
                    <span class="pl-2" style="font-weight: 600">{{
                      "importWorkflow.continueNavigation" | translate
                    }}</span>
                  </p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      } @else if (currentStep.id === 2) {
        <div class="col-12 grid">
          <div class="sm:col-12 md:col-6">
            <div class="identification-zone">
              <div class="grid">
                <!-- <div class="sm:col-12 md:col-5">
                  <div class="flex flex-column align-items-center">
                    <div class="header-identification flex">
                      <i class="pi pi-link text-xl pr-3" style="color: #c63737"></i>
                      {{ "importWorkflow.toConfirm" | translate }}
                    </div>
                    <div class="value-identification flex flex-column align-items-center">
                      <div>{{ toValidate.length }}</div>
                      <div>{{'mapping.productSheets' | translate}}</div>
                    </div>
                  </div>
                </div> -->
                <!-- <div class="sm:hidden md:col-2">
                  <p-divider class="darker-divider" layout="vertical"></p-divider>
                </div> -->
                <div class="sm:col-12 md:col-12">
                  <div class="flex flex-column align-items-center">
                    <div class="header-identification flex">
                      <i class="pi pi-question-circle text-xl pr-3" style="color: #fa8e42"></i>
                      {{ "importWorkflow.unidentified" | translate }}
                    </div>
                    <div class="value-identification flex flex-column align-items-center">
                      <div>{{ countProductNotIdentified }}</div>
                      <div>{{'mapping.productSheets' | translate}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex flex-column align-items-center mt-4">
                <p-button
                  [outlined]="true"
                  (click)="nextStep()"
                  styleClass="vertical-align-middle"
                  [disabled]="unIdentified.length === 0 && toValidate.length === 0">
                  <i class="pi pi-cog"></i>
                  <span class="pl-2" style="font-weight: 600">{{ "importWorkflow.handleErrors" | translate }}</span>
                </p-button>
              </div>

              <div class="mt-5">
                <p-message severity="info"  [closable]="false">
                    <div class="pl-2" 
                    [innerHTML]="'mapping.NotIdentifiedDetailText' | translate"
                     style="height: 155px;"></div>
                </p-message>
              </div>
 
            </div>
          </div>
          <div class="sm:col-12 md:col-6 text-right">
            <div class="identification-zone">
              <div class="grid">
                <div class="col-12">
                  <div class="flex flex-column align-items-center">
                    <div class="header-identification flex">
                      <i class="pi pi-check-circle text-xl pr-3" style="color: #22c55e"></i>
                      {{ "importWorkflow.identified" | translate }}
                    </div>
                    <div class="value-identification flex flex-column align-items-center">
                      <div>{{ countProductIdentified }}</div>
                      <div>{{'mapping.productSheets' | translate}}</div>
                    </div>
                  </div>
                  <div class="flex flex-column align-items-center mt-5">
                    <p-button [outlined]="true" styleClass="vertical-align-middle" (onClick)="validateImportWithoutHandlingErrors()" [disabled]="mappingValidated || countProductIdentified===0">
                      <i class="pi pi-check-square"></i>
                      <span class="pl-2" style="font-weight: 600">{{
                        "importWorkflow.importWithoutHandling" | translate
                      }}</span>
                    </p-button>
                  </div>
                  <div class="mt-5 text-left">
                    <p-message severity="info" [closable]="false">
                      <div class="pl-2" 
                        [innerHTML]="'mapping.identifiedDetailText' | translate"
                        style="height: 150px;"></div>
                    </p-message>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (showSpinner) {
          <div class="flex justify-content-center mt-5">
            <p-progressSpinner
              styleClass="w-4rem h-4rem"
              strokeWidth="8"
              animationDuration=".5s"
            />
          </div>
        }
      } @else if (currentStep.id == 3 && this.categoriesForUnidentified.length > 0) {
          <p-tabs [value]="0">
            <p-tablist>
              <p-tab [value]="0">
                <div pTooltip="{{ 'tooltips.mappingCategories' | translate }}" tooltipPosition="top" class="flex">
                  <i class="pi pi-question-circle text-xl pr-3" style="color: #fa8e42"></i>
                  {{ "importWorkflow.unidentified" | translate }}
                </div>
              </p-tab>
              <p-tab [value]="1">
                <div pTooltip="{{ 'tooltips.mappingCategories' | translate }}" tooltipPosition="top" class="flex">
                  <i class="pi pi-check-circle text-xl pr-3" style="color: #22c55e"></i>
                  {{ "importWorkflow.identified" | translate }}
                </div>
              </p-tab>
            </p-tablist>

            <p-tabpanels>
              <p-tabpanel [value]="0">
                <app-mapping-widget-category
                  #unIdentifiedMappingWidget
                  [nodes]="unIdentified"
                  [taxo]="categoriesForUnidentified"
                  [type]="'unIdentified'">
                </app-mapping-widget-category>
              </p-tabpanel>
              <p-tabpanel [value]="1">
                <app-mapping-widget-category
                  #identifiedMappingWidget
                  [nodes]="identified"
                  [taxo]="categoriesForIdentified"
                  [type]="'identified'"
                  [associated]="true">
                </app-mapping-widget-category>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>

      } @else if (currentStep.id == 4) {
          <p-tabs [value]="0">
            <p-tablist>
              <p-tab [value]="0">
                <div pTooltip="{{ 'tooltips.mappingAttributes' | translate }}" tooltipPosition="top" class="flex">
                  <i class="pi pi-question-circle text-xl pr-3" style="color: #fa8e42"></i>
                  {{ "importWorkflow.unidentified" | translate }}
                </div>
              </p-tab>
              <p-tab [value]="1">
                <div pTooltip="{{ 'tooltips.mappingAttributes' | translate }}" tooltipPosition="top" class="flex">
                  <i class="pi pi-check-circle text-xl pr-3" style="color: #22c55e"></i>
                  {{ "importWorkflow.identified" | translate }}
                </div>
              </p-tab>
            </p-tablist>

            <p-tabpanels>
              <p-tabpanel [value]="0">
                <app-mapping-widget-attribute
                  #unIdentifiedMappingAttributeWidget
                  [nodes]="unIdentifiedAttributes"
                  [importShopCode]="importShopCode"
                  [type]="'unIdentified'">
                </app-mapping-widget-attribute>
              </p-tabpanel>
              <p-tabpanel [value]="1">
                <app-mapping-widget-attribute
                  #identifiedMappingAttributeWidget
                  [nodes]="identifiedAttributes"
                  [importShopCode]="importShopCode"
                  [type]="'identified'">
                </app-mapping-widget-attribute>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>

      } @else if (currentStep.id == 5) {
        <!-- <p-tabView>
          <p-tabPanel> -->
            <!-- <ng-template pTemplate="header">
              <div pTooltip="{{ 'tooltips.unidentified' | translate }}" tooltipPosition="top" class="flex">
                <i class="pi pi-question-circle text-xl pr-3" style="color: #fa8e42"></i>
                {{ "importWorkflow.unidentified" | translate }}
              </div>
            </ng-template> -->
            <app-mapping-widget-value
              #mappingValueWidget
              [importShopCode]="importShopCode"
              [type]="'unIdentified'"></app-mapping-widget-value>
          <!-- </p-tabPanel> -->
          <!-- <p-tabPanel>
            <ng-template pTemplate="header">
              <div pTooltip="{{ 'tooltips.identified' | translate }}" tooltipPosition="top" class="flex">
                <i class="pi pi-check-circle text-xl pr-3" style="color: #22c55e"></i>
                {{ "importWorkflow.identified" | translate }}
              </div>
            </ng-template>
            <app-mapping-widget-value
            #identifiedMappingValueWidget
            [nodes]="identifiedValues"
            [type]="'identified'"></app-mapping-widget-value>
          </p-tabPanel> -->
        <!-- </p-tabView> -->
      }@else if (currentStep.id === 6) {
        <div class="col-12 grid">
          <div class="sm:col-12 md:col-12 text-right">
            <div class="identification-zone">
              <div class="grid">
                <div class="col-12">
                  <div class="flex flex-column align-items-center">
                    <div class="header-identification flex">
                      <i class="pi pi-check-circle text-xl pr-3" style="color: #22c55e"></i>
                      {{ "importWorkflow.identified" | translate }}
                    </div>
                    <div class="value-identification flex flex-column align-items-center">
                      <div>{{ identifiedFinal }}</div>
                      <div>{{'mapping.productSheets' | translate}}</div>
                    </div>
                  </div>
                  <div class="flex flex-column align-items-center mt-5">
                    <p-button [disabled]="mappingValidated" styleClass="vertical-align-middle" (onClick)="validateMapping(false)">
                      <i class="pi pi-check-square"></i>
                      <span class="pl-2" style="font-weight: 600">{{
                        "importWorkflow.validateImport" | translate
                      }}</span>
                    </p-button>
                  </div>
                  @if (showSpinner) {
                  <div class="flex justify-content-center mt-5">
                    <p-progressSpinner
                      styleClass="w-4rem h-4rem"
                      strokeWidth="8"
                      animationDuration=".5s"
                    />
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </p-card>
  <p-confirmDialog [style]="{width: '450px'}" />
  <p-toast></p-toast>
  <p-dialog 
  header="Header" 
  [(visible)]="showMappingInterrumptedDialog" 
  [modal]="true" 
  [closable]="false"
  [style]="{ width: '40rem' }">
      <ng-template  pTemplate="headless">
        <div class="flex flex-column px-8 py-5 gap-4" style="border-radius: 12px;">
          <div class="inline-flex align-items-center flex-column gap-2">
              <span class="font-semibold text-lg">{{'alerts.warning' | translate}}</span>
              <i class="pi pi-exclamation-circle  text-6xl"></i>
           
              <div class="bg-white-alpha-30 border-none p-3 ">
                <span class="text-800">{{'mapping.mappingInterruptedWarningText' | translate}}</span>
              </div>
          </div>
        
          <div class="flex align-items-center gap-2">
             
              <p-button [label]="'buttons.close' | translate"  (onClick)="accept()"  styleClass="p-3 w-full  border-1 border-white-alpha-30 hover:bg-blue-alpha-10" class="w-full" />
          </div>
      </div>
      </ng-template>
      
</p-dialog>

}
